// exporting from here to break cyclic dependency
export const MAX_DEPTH = 5;
export const MAX_FOLDER_DEPTH = MAX_DEPTH - 1;
export const MAX_DEPTH_FOR_COURSE_FLOW = MAX_DEPTH + 1;
export const MAX_FOLDER_DEPTH_FOR_COURSE_FLOW = MAX_DEPTH_FOR_COURSE_FLOW - 1;
